<template>
<div>
  <!-- {{withHelpText}}|{{helpTextRead}}|{{help}} -->
  <request-status :request='request' />
  <wiz-layout with-help-text
    v-model='obj'
    :steps='steps'
    :loading='request.loading'
    :active-step.sync='step'
    :help="help"
    v-on="$listeners" >

    <template slot='actions' >
      <v-divider class='mt-15' />
      <v-card-actions class='pb-5' style='min-height:90px;' >

        <v-list dense rounded shaped
          v-if='obj && obj.title && !isSuccess'
          style='position:absolute;margin-top:-32px;'
          class='elevation-5 pa-0 ml-2 grey lighten-4' >
          <v-subheader
            style='height:20px;'
            class='caption pl-4 py-1 my-0 grey lighten-2' >
            @{{spaceName}}
            <v-spacer/>
            <template v-if='obj.id' >
              <v-chip x-small label
                class='mr-2' color='info' >editing</v-chip>
              <v-btn x-small icon @click='reset' >
                <v-icon x-small >mdi-close</v-icon>
              </v-btn>
            </template>
            <v-chip v-else x-small outlined label
              class='mr-2' >preview</v-chip>
          </v-subheader>
          <v-divider/>
          <v-list-item >
            <v-list-item-content>
              <v-list-item-title v-text='obj.title' />
              <v-list-item-subtitle v-if='practitioner && practitioner.full_name' >
                with {{practitioner.full_name}}
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if='obj.duration' >
                {{obj.duration}} minutes
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if='obj.locations && obj.locations.length > 0' >
                <!-- {{obj.locations}} -->
                <template v-for='loc in obj.locations' >
                  <location-chip v-if='loc.id'
                    :key='loc.id'
                    :space-id='spaceId'
                    :location-id='loc.id' class='mr-1'
                    :attrs="{'label': true, 'outlined': true, 'x-small': true}" />
                  <location-chip v-else
                    :key='loc'
                    :space-id='spaceId'
                    :location-id='loc' class='mr-1'
                    :attrs="{'label': true, 'outlined': true, 'x-small': true}" />
                </template>
                <!-- {{obj.locations}} -->
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-if='obj.price && obj.price > 0' >
              {{ formatCurrency(currency, obj.price) }}
            </v-list-item-action>
            <v-list-item-action v-if='obj.id' >
              <v-btn text @click='reset' >
                Clear
              </v-btn>
            </v-list-item-action>
            <v-list-item-action >
              <v-btn
                :disabled='!isValid'
                :loading='request.loading'
                @click='create'
                color='primary'
                class='px-5' >
                <template v-if='obj.id' >Save</template>
                <template v-else >Create</template>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <!-- <v-spacer/> -->
      </v-card-actions>

      <v-menu v-if='obj && obj.practitioner' nudge-bottom bottom >
        <template v-slot:activator="{ on }">
        <v-btn v-on='on' slot='activator' outlined block tile class='mb-3' >
          <v-progress-circular
            v-if='globalInitLoading'
            color='amber' indeterminate width='2' />

          <v-badge v-if='productPreview && productPreview.length > 0 && !globalInitLoading'
            class='mr-6 mt-3'
            :content='productPreview.length' ></v-badge>

          Appointment Types

          <span v-if='practitioner && practitioner.full_name' class='ml-1' >
            for {{ practitioner.full_name }}
          </span>
          <v-spacer />
          <v-divider vertical class='mr-2' />
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
        </template>
        <v-list dense tile class='pa-0' >
          <template v-for='product in productPreview' >
            <v-list-item :key='product.id' >
              <v-list-item-content>
                <v-list-item-title v-text='product.title' />
              </v-list-item-content>
              <v-divider vertical />
              <v-list-item-action >
                <v-btn @click='setObject(product)' icon small color='primary' class='mx-3' >
                  <v-icon small >mdi-pencil</v-icon>
                </v-btn>
              </v-list-item-action>
              <v-divider vertical />
              <v-list-item-action v-if='product && product.id' >
                <v-btn @click='confirmDeleteDialog=true;selectedToDelete=product;' icon small color='error' >
                  <v-icon small >mdi-delete</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-divider :key='`div-${product.id}`' />
          </template>
        </v-list>
      </v-menu>
    </template>
  </wiz-layout>
  <v-dialog v-model='confirmDeleteDialog' >
    <v-card v-if='selectedToDelete'>
      <v-card-title class='subtitle-1 overline' >
        Are you sure you want to delete {{selectedToDelete.title}}
        <v-spacer/>
        <v-btn @click='confirmDeleteDialog=false' icon >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>

      </v-card-text>
      <v-card-actions >
        <v-btn text @click='confirmDeleteDialog=false' >Cancel</v-btn>
        <v-spacer/>
        <v-btn
          @click='removeProduct(selectedToDelete.id)' color='error' :loading='delRequest.loading' >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- {{obj}} -->
</div>
</template>
<script>
import WizLayout from '@/components/actions/wizards/CarouselLayout.vue'
import LocationPicker from '@/components/pickers/LocationPicker.vue'
import LocationChip from '@/components/listitems/LocationChip.vue'
import InlinePractitionerPicker from '@/components/pickers/InlinePractitionerPicker.vue'
import SuccessScreen from '@/components/actions/wizards/SuccessScreen.vue'

import {mapGetters} from 'vuex'
import Vue from 'vue'

const STEPS = {
  PRACTITIONER: 1,
  NAME: 2,
  DURATION: 3,
  PRICE: 4,
  LOCATION: 5
}

export default {
  name: 'AppointmentTypeWizard',
  props: {
    spaceId: { required: true },
    practitionerId: { required: false },
    value: { type: Object, required: false },
    touch: { type: Number, default: 0 },
    title: { type: String, required: false },
    withList: { type: Boolean, default: true },
    withHelpText: { type: Boolean, default: false },
    customSuccessSteps: { type: Array, required: false }
  },
  components: {WizLayout, LocationChip},
  data () {
    return {
      step: 1,
      success: false,
      confirmDeleteDialog: false,
      selectedToDelete: {},
      STEPS: STEPS,
      obj: {
        practitioner: null,
        title: '',
        duration: 30,
        price: null,
        location: []
      },
      request: {
        resource: 'ag.spaces',
        extra: 'appointment-types',
        status: 0
      },
      delRequest: {
        resource: 'ag.spaces',
        extra: 'appointment-types'
      }
    }
  },
  mounted () {
    this.setFocus()
  },
  watch: {
    step () {
      this.setFocus()
    },
    touch () {
      this.reset()
    },
    value: {
      immediate: true,
      handler () {
        if (this.value) {
          window.setTimeout(() => {
            this.setObject(this.value)
          }, 500)
        }
      }
    },
    practitionerId: {
      immediate: true,
      handler () {
        if (this.practitionerId) {
          window.setTimeout(() => {
            Vue.set(this.obj, 'practitioner', this.practitionerId)
          }, 500)
          // console.log(this.obj, 'practitioner', this.practitionerId)
          // this.step = STEPS.NAME
          this.success = false
        }
        // console.log(this.obj.practitioner)
      }
    },
    requestStatus () {
      if (this.requestStatus === 201 || this.requestStatus === 200) {
        this.success = true
        // console.log(this.steps.length)
        let successStep = this.findStepIndex('success') + 1
        this.step = successStep
        this.$emit('saved', this.request.result)
        this.obj = this.request.result
        this.init()
      }
    },
    delRequestStatus () {
      if (this.delRequestStatus === 204) {
        this.init()
        this.confirmDeleteDialog = false
      }
    }
  },
  methods: {
    setFocus () {
      let s = this.steps[this.step]
      if (s && s.id) {
        window.setTimeout(() => {
          let el = document.getElementById(s.id)
          if (el) { el.focus() }
        }, 300)
      }
    },
    setObject (product, gotoStep) {
      if (product) {
        this.obj = product
        this.obj.locations = product.locations.map((loc) => {
          if (loc) {
            if (isNaN(loc)) {
              return loc.id
            } else {
              return loc
            }
          }
          if (gotoStep) { this.step = gotoStep }
        })
      }
    },
    reset () {
      this.success = false

      this.obj = {}
      Vue.set(this.obj, 'id', null)
      Vue.set(this.obj, 'practitioner', null)
      Vue.set(this.obj, 'title', null)
      Vue.set(this.obj, 'duration', null)
      Vue.set(this.obj, 'price', null)
      Vue.set(this.obj, 'location', [])

      if (this.practitionerId) {
        Vue.set(this.obj, 'practitioner', this.practitionerId)
        this.step = STEPS.NAME
      } else {
        this.step = STEPS.PRACTITIONER
      }
    },
    create () {
      this.request.resourceId = this.spaceId
      this.request.data = this.payload
      this.request.method = 'post'
      this.request.extra = 'appointment-types'
      if (this.obj.id) {
        this.request.method = 'patch'
        this.request.extra = 'appointment-types/' + this.obj.id
      }
      this.$request('save', this.request)
    },
    removeProduct (objId) {
      this.delRequest.resourceId = this.spaceId
      this.delRequest.extra = 'appointment-types/' + objId
      this.$request('delete', this.delRequest)
    },
    findStepIndex (stepId) {
      return this.steps.findIndex((step) => {
        return step.id === stepId
      })
    }
  },
  computed: {
    ...mapGetters('identity', [
      'getPractitionerById',
      'getProducts'
    ]),
    isValid () {
      if (this.obj && this.obj.title && this.obj.duration && this.obj.price && this.obj.locations && this.obj.locations.length > 0) {
        return true
      }
      return false
    },
    activeStepConfig () {
      if (this.steps && this.step && this.step > 0) {
        return this.steps[this.step - 1]
      }
      return {}
    },
    isSuccess () {
      return this.activeStepConfig.id === 'success'
    },
    fabcolor () {
      if (this.success) { return 'success' }
      return 'info'
    },
    cardcolor () {
      if (this.success) { return 'success' }
      return 'orange'
    },
    requestStatus () {
      return this.request.status
    },
    delRequestStatus () {
      return this.delRequest.status
    },
    productId () {
      return this.getObjectPath(this.request, 'result.id', null)
    },
    detailPath () {
      if (this.productId) {
        return `/settings/spaces/${this.spaceId}/appointment-types/${this.productId}`
      }
      return null
    },
    practitioner () {
      if (this.obj && this.obj.practitioner) {
        return this.getPractitionerById(this.obj.practitioner)
      }
      return null
    },
    productPreview () {
      let practitionerId = this.getObjectPath(this.obj, 'practitioner', this.practitionerId)
      let spaceId = this.spaceId
      return this.getProducts({spaceId, practitionerId}).filter((product) => {
        return (product.is_archived !== true)
      })
    },
    payload () {
      let practitionerId = this.obj.practitioner
      if (!practitionerId) { practitionerId = this.practitionerId }
      let data = {
        service: this.spaceId,
        practitioner: practitionerId,
        title: this.obj.title,
        price: this.obj.price,
        duration: this.obj.duration,
        locations: this.obj.locations
      }
      return data
    },
    successSteps () {
      if (this.customSuccessSteps) { return this.customSuccessSteps }
      let vm = this
      let steps = [
        {
          text: 'Add another',
          icon: 'mdi-arrow-left',
          click: () => { vm.reset() }
        }
      ]
      if (vm.spaceId && vm.obj && vm.obj.id) {
        steps.push({
          text: 'Continue editing',
          icon: 'mdi-arrow-right',
          click: () => {
            vm.$emit("close")
            let path = `/settings/spaces/${vm.spaceId}/appointment-types/${vm.obj.id}`
            vm.$router.push({path})
            vm.reset()
          }
        })
      }
      steps.push({
        text: 'Done',
        click: () => {
          vm.$emit("close")
          vm.reset()
        }
      })
      return steps
    },
    steps () {
      let vm = this
      return [
        {
          id: 'practitioner',
          title: 'Choose a practitioner',
          hint: 'Choose the practitioner who will serve this appointment',
          allowback: false,
          attrs: {
            multiple: false,
            spaceId: this.spaceId,
            value: this.practitionerId,
            practitionerId: this.practitionerId
          },
          events: {
            selected () {
              if (vm.obj && vm.obj.practitioner) {
                if (vm.step === 1) {
                  vm.step++
                }
              }
            }
          },
          component: InlinePractitionerPicker
        },
        {
          id: 'title',
          title: 'Name',
          hint: 'The name of your appointment type',
          attrs: {},
          validator: (step, obj) => {
            return (obj.title && obj.title.length > 1)
          }
        },
        {
          id: 'duration',
          title: 'Duration',
          hint: 'How long are these appointments typically (minutes)?',
          attrs: {
            type: 'number'
          },
          validator: (step, obj) => {
            return (obj.duration && obj.duration.length > 1 && (isNaN(obj.duration) === false))
          }
        },
        {
          id: 'price',
          title: 'Price',
          hint: 'How much does it cost?',
          attrs: {
            type: 'number'
          },
          validator: (step, obj) => {
            let val = parseInt(obj.price)
            if (val === 0) { return true } // explicitly allow 0
            return (obj.price && isNaN(obj.price) === false)
          }
        },
        {
          id: 'locations',
          title: 'Pick locations',
          hint: 'At which locations is this appointment type available',
          attrs: {
            inline: true,
            multiple: true,
            spaceId: this.spaceId
          },
          component: LocationPicker,
          validator: () => {
            return false
          }
        },
        {
          id: 'success',
          title: 'Successfully created',
          attrs: {
            value: vm.obj,
            actions: this.successSteps
          },
          validator: () => { return false },
          allowback: false,
          skipable: false,
          component: SuccessScreen
        }
      ]
    },
    help () {
      return {
        // title: 'Appointment types',
        description: 'Appointment types are like templates that can be used to set default values when you create new appointments',
        listitems: [
          'When booking online (if enabled), the client will be able to select an appointment type',
          'Appointment types can be: <strong>normal</strong> (the default), <strong>virtual</strong> (for online appointment types) or <strong>flexble</strong> (e.g.: for home visits)',
          'The appointment type will set a <strong>default duration and price</strong> for an appointment',
          'They can also be used to <strong>automatically add ICD-10 codes</strong>',
          'You can use appointment types to inject specific information into your notifications and on your appointment page'
        ],
        ctaText: 'Got it. Let\'s go!'
      }
    }
  }
}
</script>
